import clsx from 'clsx'
import React, { FC } from 'react'

import { NavLinkClickProperties } from '@Analytics/ampli'
import { ImageV4 } from '@Components/Image'
import { Link } from '@Components/Link'

import styles from './ProductItem.module.scss'

export interface ProductItemProps {
  action?: React.ReactNode
  analytics?: NavLinkClickProperties
  className?: string
  content: string | React.ReactNode
  disabled?: boolean
  discount?: string
  imageUrl: string
  price?: string
  url?: string
}

export const ProductItem: FC<ProductItemProps> = (
  { action,
    analytics,
    className,
    content,
    disabled,
    discount,
    imageUrl,
    price,
    url },
) => (
  <div className={clsx(className, styles.productItem, { [styles.disabled]: disabled })}>
    {url
      ? (
        <Link analytics={analytics} className={styles.imageWrapper} href={url || ''}>
          <ImageV4 height={90} src={imageUrl} width={90} />
        </Link>
      )
      : (
        <div className={styles.imageWrapper}>
          <ImageV4 height={90} src={imageUrl} width={90} />
        </div>
      )}
    <div className={styles.contentWrapper}>
      {url
        ? <Link analytics={analytics} className={styles.content} href={url || ''}>{content}</Link>
        : <div className={styles.content}>{content}</div>}
      <div className={styles.actions}>
        {price && (
          <span className={styles.prices}>
            {discount && <span className={styles.discount}>{discount}</span>}
            <span className={clsx(styles.price, discount && styles.discounted)}>{price}</span>
          </span>
        )}
        {action && (
          <div className={styles.action}>
            {action}
          </div>
        )}
      </div>
    </div>
  </div>
)
